<template>
  <div>
    <div class="db-filter-modal">
      <div class="db-filter-title-text">Edit Tujuan Pendaftaran</div>
      <div class="db-filter-edit-form">
        <div class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">Deskripsi</div>
          <div class="db-filter-hiw-full">
            <input type="text" class="db-filter-hiw-text" v-model="editData.name" />
          </div>
        </div>
        <div class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">Landing Page</div>
          <div class="db-filter-hiw-multiple">
            <select class="db-filter-hiw-select-full" v-model="editData.is_landingpage">
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
          </div>
        </div>
        <div class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">Registrasi ke Ariba</div>
          <div class="db-filter-hiw-multiple">
            <select class="db-filter-hiw-select-full" v-model="editData.ariba_registration">
              <option value="No Editable (Check)">No Editable (Check)</option>
              <option value="No Editable (Uncheck)">No Editable (Uncheck)</option>
              <option value="Editable (Check)">Editable (Check)</option>
              <option value="Editable (Uncheck)">Editable (Uncheck)</option>
            </select>
          </div>
        </div>
        <div class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">Registrasi ke SAP GEMS</div>
          <div class="db-filter-hiw-multiple">
            <select class="db-filter-hiw-select-full" v-model="editData.gems_registration">
              <option value="No Editable (Check)">No Editable (Check)</option>
              <option value="No Editable (Uncheck)">No Editable (Uncheck)</option>
              <option value="Editable (Check)">Editable (Check)</option>
              <option value="Editable (Uncheck)">Editable (Uncheck)</option>
            </select>
          </div>
        </div>
        <div class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">Registrasi ke SAP BCE</div>
          <div class="db-filter-hiw-multiple">
            <select class="db-filter-hiw-select-full" v-model="editData.bce_registration">
              <option value="No Editable (Check)">No Editable (Check)</option>
              <option value="No Editable (Uncheck)">No Editable (Uncheck)</option>
              <option value="Editable (Check)">Editable (Check)</option>
              <option value="Editable (Uncheck)">Editable (Uncheck)</option>
            </select>
          </div>
        </div>
        <div class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">Registrasi ke BKES</div>
          <div class="db-filter-hiw-multiple">
            <select class="db-filter-hiw-select-full" v-model="editData.bkes_registration">
              <option value="No Editable (Check)">No Editable (Check)</option>
              <option value="No Editable (Uncheck)">No Editable (Uncheck)</option>
              <option value="Editable (Check)">Editable (Check)</option>
              <option value="Editable (Uncheck)">Editable (Uncheck)</option>
            </select>
          </div>
        </div>
        <div class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">Catatan</div>
          <div class="db-filter-hiw-full">
            <input type="text" class="db-filter-hiw-text" v-model="editData.note" />
          </div>
        </div>
        <div class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">Status</div>
          <div class="db-filter-hiw-multiple">
            <select class="db-filter-hiw-select" v-model="editData.status">
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>
          </div>
        </div>
      </div>
      <div class="button-container">
        <div class="button-wrapper">
          <div class="email-button" @click="closeModal">CANCEL</div>
          <div class="email-button" @click="update">CONFIRM</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { api } from '../../../../services/config'
export default {
  data() {
    return {
      editData: {
        name: '',
        is_landingpage: true,
        ariba_registration: 'No Editable (Check)',
        gems_registration: 'No Editable (Check)',
        bce_registration: 'No Editable (Check)',
        bkes_registration: 'No Editable (Check)',
        update_by: '',
        status: true,
        note: '',
      },
    }
  },

  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
    async update() {
      try {
        const update = this.editData
        update.update_by = this.$store.state.userid
        const url = `${api}/api/v1/m-purpose-ticket`
        this.$store.commit('SET_GLOBAL_LOADING', true)

        const { data } = await axios({
          method: 'POST',
          url,
          data: this.editData,
        })

        if (data && data.status == 'success') {
          this.closeModal()
          this.$store.dispatch('mdDatabaseStore/onPageLoad', {
            name: 'currentContent',
            value: 'tujuan_pendaftaran',
          })
          this.$store.commit('SET_GLOBAL_LOADING', false)
        }
      } catch (err) {
        this.$store.commit(
          'SET_NOTIF',
          this.$get(err, 'response.data.message', 'Error')
        )
        this.$store.commit('SET_GLOBAL_LOADING', false)
      }
    },
  },
}
</script>
